import React from 'react';
//eslint-disable-next-line
import styles from "./styles.scss";

const RentalMetaInfo = props => {
  const { name, location, houseCount } = props.data;
  return (
    <div className={'rental-card-info'}>
      <h3>{name}</h3>
      <div className={'rental-info'}>
        <span className={'location'}>{location}</span>
        <span className={'house-count'}>
          {houseCount === 1
            ? `${houseCount} home for rent`
            : `${houseCount} homes for rent`}
        </span>
      </div>
    </div>
  );
};

export default RentalMetaInfo;
